import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import { SCREENING_FREQUENCIES } from '@/constants/institution';
import type { InstitutionKycCddOrDefaults } from '@/features/institution/kyc-cdd/schema';

const InstitutionKycCddFieldsetScreening = () => {
  const form = useFormContext<InstitutionKycCddOrDefaults>();
  const { t } = useTranslation();
  const screensCustomers = form.watch('screensCustomers');

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="screensCustomers"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.screening.screensCustomers')}*</FormLabel>
            <FormControl>
              <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.kycCdd.screening.screensCustomers')} onValueChange={field.onChange}>
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {screensCustomers === 'YES' ? (
        <FormField
          control={form.control}
          name="screeningFrequency"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('institutionDetails.kycCdd.screening.screeningFrequency')}*</FormLabel>
              <FormControl>
                <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.kycCdd.screening.screeningFrequency')} onValueChange={field.onChange}>
                  {SCREENING_FREQUENCIES.map((frequency) => (
                    <FormItem key={frequency}>
                      <RadioGroupItemCard variant="outline">
                        <FormControl>
                          <RadioGroupItem value={frequency} />
                        </FormControl>
                        <FormLabel contained>{t(`institutionDetails.kycCdd.screening.screeningFrequencyOptions.${frequency}`)}</FormLabel>
                      </RadioGroupItemCard>
                    </FormItem>
                  ))}
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ) : null}
      <FormField
        control={form.control}
        name="riskBasedPepScreening"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.screening.riskBasedPepScreening')}*</FormLabel>
            <FormControl>
              <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.kycCdd.screening.riskBasedPepScreening')} onValueChange={field.onChange}>
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="hasKycReviewProcess"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.screening.hasKycReviewProcess')}*</FormLabel>
            <FormControl>
              <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.kycCdd.screening.hasKycReviewProcess')} onValueChange={field.onChange}>
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionKycCddFieldsetScreening.displayName = 'InstitutionKycCddFieldsetScreening';

export { InstitutionKycCddFieldsetScreening };
